<template>
  <div class="fullscrean text-muted">
    <div>
      <img src="../assets/logo-lecard.png" alt="Logo Lecard" style="width: 120px">
      <div class="mt-3">
        <div v-if="!load">
          <h5 class="mb-2 font-weight-bold">Atualize seu Gestor</h5>
          <p class="mb-3" style="max-width: 550px">
            Sua versão atual está desatualizada.
            Clique em "Atualizar versão" para continuar ou em caso de dúvidas, entre em contato com o nosso suporte pelo WhatsApp: (16) 99453-3763.
          </p>
          <button class="btn btn-primary px-4" @click="atualizar()" :disabled="load">
            {{ load ? 'Baixando a versão..' : 'Atualizar versão' }}
          </button>
          <div class="d-flex justify-content-center small mt-4">
            <div>
              Web: <b :class="outDateWeb ? 'text-danger' : ''">{{ app_version }}</b>
              <i class="fa fa-circle text-danger ml-1" v-if="outDateWeb"></i>
              <i class="fa fa-check text-success ml-1" v-else></i>
            </div>
            <div v-if="electronV">
              <span class="mx-2">|</span>Desktop: <b :class="outDateElectron ? 'text-danger' : ''">{{ electronV | version }}</b>
              <i class="fa fa-circle text-danger ml-1" v-if="outDateElectron"></i>
              <i class="fa fa-check text-success ml-1" v-else></i>
            </div>
          </div>
        </div>
        <div v-else>
          <h5 class="mb-2 font-weight-bold">{{ title }}</h5>
          <p class="mb-3" style="max-width: 550px">{{ mensagem }}</p>
          <loading v-if="step < 2"/>
          <div class="mt-4 mx-auto text-center" v-else-if="step === 2" style="width: 260px">
            <div class="progress mb-2">
              <div class="progress-bar bg-primary" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100" :style="`width:${progress}%`"></div>
            </div>
            {{ progress | percent }}%
          </div>
          <button class="btn btn-primary px-4" v-else-if="step === 4" @click="atualizar()">Tentar novamente</button>
          <a href="/" class="btn btn-primary px-4" v-else-if="step === 5">Voltar</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "@/components/commons/TopBar";
  import Loading from "@/components/commons/Loading";
  export default {
    name: 'Upgrade',
    components: {Loading, TopBar},
    data() {
      return {
        load: false,
        outDateWeb: false,
        outDateElectron: false,
        isDownload: false,
        title: '',
        mensagem: '',
        step: 0,
        progress: 0
      }
    },

    methods: {
      atualizar() {
        this.load = true;
        this.progress = 0;
        this.step = 0;

        if (this.isElectron && this.electronV) {
          if (this.electronV < 178) {
            this.title = 'Para atualizar sua versão'
            this.mensagem = 'Clique no menu "Ajuda" e depois em "Verificar atualizações"';
            this.step = 3;

          } else {
            this.title = 'Verificando atualização';
            this.mensagem = 'Por favor aguarde.';
            document.dispatchEvent(new CustomEvent('update', { detail: { outdate: true } }));
          }

        } else {
          window.location.href = '/'
        }
      },

      updateReply(opt) {
        const reply = opt ? (opt.detail || {}) : {};
        this.title = reply.message;
        this.mensagem = reply.detail;
        this.step = reply.step;
      },

      updateProgress(opt) {
        this.progress = opt.detail || 0;
      }
    },

    mounted() {
      this.outDateWeb = this.version.gestor_web > parseInt(this.app_version.replace(/[^0-9]/g, ''));

      if (this.isElectron) {
        this.outDateElectron = this.version.app_electron > this.electronV;
      }
    },

    created() {
      if (this.isElectron) {
        document.addEventListener("updateReply", this.updateReply, false);
        document.addEventListener("updateProgress", this.updateProgress, false);
      }
    },

    computed: {
      version() {
        return this.$store.state.version;
      }
    },

    beforeDestroy() {
      document.removeEventListener('updateReply', this.updateReply);
      document.removeEventListener('updateProgress', this.updateProgress);
    },

    filters: {
      version(v) {
        return (v || '').toString().split("").join(".");
      }
    }
  }
</script>

<style scoped>
.fullscrean {
  display: flex;
  height: 96vh;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  width: 100%;
  text-align: center;
}

@media (max-height: 550px) {
  .fullscrean {
    height: auto;
    margin-top: 130px;
  }
}
</style>
